import { Accordion, AccordionTab } from "primereact/accordion";
import React, { useEffect, useState } from "react";

const GarmentInfoQrCodeCard = ({ readyToDeliveryData }) => {

  const OrderStatusColors = {
    BOOKED: "#3EB3E1",
    INPROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERY: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  return (
    <div className="mx-2 mt-4 flex-1 max-h-19rem" style={{overflowY:"auto"}}>
      <Accordion>
        {readyToDeliveryData?.map((item, index) => {
          const orderStatusColor =
            OrderStatusColors[item.status] || OrderStatusColors.BOOKED;

          const serviceName = item.addOnList
            .map((addOnItem) => addOnItem.serviceName)
            .join(", ");

          const offerPrice = item.addOnList
            .map((addOnItem) => addOnItem.offerPrice)
            .join(", ");

          const garmentName =
            item.garmentAlias !== "" ? item.garmentAlias : item.garment;
          return (
            <AccordionTab
              key={index}
              style={{
                "--backgroundColor-AccordionTab": orderStatusColor,
              }}
              header={`${index + 1 || "N/A"} | Tag : ${item.qrcode}`}
            >
              <div className="cursor-pointer">
                <div className="flex-row">
                  <div className="col-12">
                    <p className="text-base font-semiBold capitalize">
                      Service:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {serviceName || "N/A"}
                    </p>
                  </div>
                </div>
                <div className="flex-row">
                  <div className="col-6 flex justify-content-between">
                    <div>
                      <p className="text-base font-semiBold capitalize">
                        Pack on:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {item.garmentPack}
                      </p>
                    </div>
                  </div>
                  <div className="col-6 flex justify-content-between">
                    <div>
                      <p className="text-base font-semiBold capitalize">
                        Offer Price:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {offerPrice}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex-row">
                  <div className="col-6">
                    <p className="text-base font-semiBold capitalize">
                      Garment:
                    </p>
                    <p className="text-lg font-bold capitalize">
                      {garmentName.replace(/_/g, " ")}
                    </p>
                  </div>
                  <div className="col-6">
                    <p className="text-base font-semiBold capitalize">
                      Status:
                    </p>
                    <p
                      className="text-lg font-bold capitalize"
                      style={{ color: orderStatusColor }}
                    >
                      {item.status.replace(/_/g, " ")}
                    </p>
                  </div>
                </div>
              </div>
            </AccordionTab>
          );
        })}
      </Accordion>
    </div>
  );
};

export default GarmentInfoQrCodeCard;
